<div class="bg-primary text-center">
    <h2 mat-dialog-title class="mat-mdc-dialog-title text-white">
        {{productData.name}}
    </h2>
</div>

<mat-dialog-content class="mat-mdc-dialog-content text-right">
    <form [formGroup]="PricingForm">
        <div class="col-md-12">
            <mat-form-field appearance="outline" class="w-100">
                <input matInput type="number" class="inputTxt" min="1" formControlName="Quantity"
                    placeholder="{{ 'Quantity' | translate }}" />

                @if(f['Quantity'].touched && f['Quantity'].invalid)
                {
                <mat-hint class="m-b-16 error-msg">
                    @if(f['Quantity'].errors && f['Quantity'].errors['required'])
                    {
                    <div class="text-error"> {{ 'EnterQuantity' | translate }}</div>
                    }
                </mat-hint>
                }
            </mat-form-field>

            <div *ngIf="!OnlyQuantity">
                <div>
                    <mat-radio-group>
                        <mat-radio-button value="{{ 'roll' | translate }}" color="primary">
                            {{ 'roll' | translate}}</mat-radio-button>

                        <mat-radio-button value="{{ 'Oud' | translate }}" color="primary" checked="checked">
                            {{ 'Oud' | translate }}
                        </mat-radio-button>
                    </mat-radio-group>
                </div>

                <div class="divData">
                    <span> 90</span>
                    <span class="span-title">{{ 'IronPrice' | translate }}</span>
                </div>

                <mat-form-field appearance="outline" class="w-100 ">
                    <input matInput type="number" class="inputTxt" min="1" formControlName="IronQuantity"
                        placeholder="{{ 'Quantity' | translate }}" />

                    @if(f['IronQuantity'].touched && f['IronQuantity'].invalid)
                    {
                    <mat-hint class="m-b-16 error-msg">
                        @if(f['IronQuantity'].errors && f['IronQuantity'].errors['required'])
                        {
                        <div class="text-error"> {{ 'EnterQuantity' | translate }}</div>
                        }
                    </mat-hint>
                    }
                </mat-form-field>
            </div>
        </div>
    </form>
</mat-dialog-content>

<mat-dialog-actions>
    <mat-divider></mat-divider>
    <div class="col-sm-12 text-left">
        <button mat-flat-button class="Cancelbtn" (click)="Cancel()">
            {{ 'Cancel' | translate }}
        </button>
        <button mat-flat-button class="orangSavebtn" (click)="Save(PricingForm)">
            {{ 'Save' | translate }}
        </button>
    </div>
</mat-dialog-actions>